var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKooderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-4, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-5);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1083.7,1634.7v355c-152.1,141-388.9,135.2-534.1-13.1l-190.6-194.9v-1.3L36,1448.5c-15.5-15.9-15.5-41.2,0-57.2l410.3-421.6c7.7-7.9,18.3-12.4,29.4-12.4h249.1c36.2,0,54.6,43.6,29.4,69.6l-354.7,364.4c-15.5,15.9-15.5,41.2,0,57.2l244.6,251.3c.7.8,1.5,1.5,2.3,2.2,104.5,93.3,264.3,93,368.6-3.6l68.8-63.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19.3,
    y: 952.4,
    width: 1069.4,
    height: 1144.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19.3,
    y: 952.4,
    width: 1069.4,
    height: 1144.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2245.9,1812.9l354.6-364.4c15.5-15.9,15.5-41.2,0-57.2l-288.2-296.1c-.7-.7-1.5-1.5-2.2-2.2-78.1-69.8-197.6-69.6-275.5,2.6l-358.2,345.4c-16.3,15.7-16.8,41.7-1,58,.2.2.3.3.5.5l552.3,552.3c25.8,25.8,7.5,69.9-29,69.9h-258.2c-10.9,0-21.3-4.3-29-12l-427.7-427.8c-15.8-15.8-41.3-16-57.4-.5l-41.5,40c-8,7.7-12.5,18.4-12.5,29.5v487.3c0,22.6-18.4,41-41,41h-207.1c-22.6,0-41-18.4-41-41V792.1c0-22.6,18.4-41,41-41h207.1c22.6,0,41,18.4,41,41v490.1c0,36.2,43.5,54.6,69.5,29.4l523.3-507.2c124.7-115.5,318.7-110.8,437.5,10.8l237.8,243.1v1.3l322.9,331.8c15.5,15.9,15.5,41.2,0,57.2l-410.3,421.6c-7.7,7.9-18.3,12.4-29.4,12.4h-249.1c-36.2,0-54.6-43.6-29.4-69.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1078.8,
    y: 715.8,
    width: 1901.9,
    height: 1568.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1078.8,
    y: 715.8,
    width: 1901.9,
    height: 1568.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1083.7,1634.7v355c-152.1,141-388.9,135.2-534.1-13.1l-190.6-194.9v-1.3L36,1448.5c-15.5-15.9-15.5-41.2,0-57.2l410.3-421.6c7.7-7.9,18.3-12.4,29.4-12.4h249.1c36.2,0,54.6,43.6,29.4,69.6l-354.7,364.4c-15.5,15.9-15.5,41.2,0,57.2l244.6,251.3c.7.8,1.5,1.5,2.3,2.2,104.5,93.3,264.3,93,368.6-3.6l68.8-63.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.3,
    y: 952.4,
    width: 1069.4,
    height: 1144.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.3,
    y: 952.4,
    width: 1069.4,
    height: 1144.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -811.7,
    y: -237,
    width: 3557.1,
    height: 3759.3
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2245.9,1812.9l354.6-364.4c15.5-15.9,15.5-41.2,0-57.2l-288.2-296.1c-.7-.7-1.5-1.5-2.2-2.2-78.1-69.8-197.6-69.6-275.5,2.6l-358.2,345.4c-16.3,15.7-16.8,41.7-1,58,.2.2.3.3.5.5l552.3,552.3c25.8,25.8,7.5,69.9-29,69.9h-258.2c-10.9,0-21.3-4.3-29-12l-427.7-427.8c-15.8-15.8-41.3-16-57.4-.5l-41.5,40c-8,7.7-12.5,18.4-12.5,29.5v487.3c0,22.6-18.4,41-41,41h-207.1c-22.6,0-41-18.4-41-41V792.1c0-22.6,18.4-41,41-41h207.1c22.6,0,41,18.4,41,41v490.1c0,36.2,43.5,54.6,69.5,29.4l523.3-507.2c124.7-115.5,318.7-110.8,437.5,10.8l237.8,243.1v1.3l322.9,331.8c15.5,15.9,15.5,41.2,0,57.2l-410.3,421.6c-7.7,7.9-18.3,12.4-29.4,12.4h-249.1c-36.2,0-54.6-43.6-29.4-69.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1078.8,
    y: 715.8,
    width: 1901.9,
    height: 1568.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1078.8,
    y: 715.8,
    width: 1901.9,
    height: 1568.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -198.2,
    y: -349.6,
    width: 3557.1,
    height: 3759.3
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKooderWhite);
export default __webpack_public_path__ + "static/media/kooder-white.22c3e0948060656935fa1a17774c109c.svg";
export { ForwardRef as ReactComponent };